import { apiGet, apiPost } from '@/api/http';

import type { Skill } from '@/types/reference';

const api_url = import.meta.env.VITE_API_URL;

export const getSkillsList = () => apiGet<Skill[]>(`${api_url}skills/`);

export const createNewSkill = (newSkill: string) =>
  apiPost<Skill>(`${api_url}skills/`, { name: newSkill });
